import {
    AUTH_USER,
    AUTH_USER_SUCCESS
} from '../actions'
import { jwtDecode } from "jwt-decode";


const INIT_STATE = {
    auth_user: localStorage.getItem('auth_user') != null ? JSON.parse(localStorage.getItem('auth_user')) : []
    //เช็คค่าใน localStorageว่า state ไม่เท่ากับ null ไหม ถ้า True ทำการนำข้อมูล auth_user แปลงเป็น Jsonjavascript array

};

export default (state = INIT_STATE, action) => {
    switch (action.type) {

        case AUTH_USER:
          
            return { ...state, loading: true }

        case AUTH_USER_SUCCESS:
       
            const expAt = jwtDecode(action.payload[0].accessToken).exp;
            localStorage.setItem('auth_user', JSON.stringify(action.payload))
            localStorage.setItem('expAt', expAt)
            return { ...state, loading: false, auth_user: action.payload }

        default: return { ...state };
    }
}